import { apiSlice } from "@/shared/api/api-slice"
import type { TopupPack } from "@/shared/types/api/business-mode.types"

export const getTopupPacksApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["TopupPacks"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      getTopupPacks: builder.query<TopupPack[], undefined>({
        query: () => `/api/v1/business/subscriptions/topup-packs`,
        providesTags: () => [{ type: "TopupPacks" as const }]
      })
    })
  })

export const { useGetTopupPacksQuery } = getTopupPacksApi
